<template>
  <div id="app">
    <router-view/>
    <OrientationWarning />
  </div>
</template>

<style>
#app {
  text-align: center;
  color: #2c3e50;
  font-family: "GenSenRoundedTW", "Noto Sans", sans-serif;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none;   /* Chrome, Safari, Opera */
  -khtml-user-select: none;    /* Early versions */
  -moz-user-select: none;      /* Firefox */
  -ms-user-select: none;       /* Internet Explorer/Edge */
  user-select: none;      
}

nav {
  padding: 30px;
  position: absolute;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
<script>
import AOS from 'aos'
import 'aos/dist/aos.css'
import { isMobile, getDeviceInfo } from '@/utils/deviceDetection'
import OrientationWarning from '@/components/OrientationWarning.vue'

export default {
  components: {
    OrientationWarning
  },
  data() {
    return {
      resizeTimer: null,
      isCheckingDevice: false
    }
  },
  mounted () {
    AOS.init()
    this.startDeviceMonitoring()
  },
  beforeUnmount() {
    this.stopDeviceMonitoring()
  },
  methods: {
    // 開始裝置監控
    startDeviceMonitoring() {
      // 初始檢查
      this.checkDevice()
      
      // 監聽視窗大小改變（用戶可能調整瀏覽器視窗或旋轉裝置）
      window.addEventListener('resize', this.handleResize)
      
      // 監聽方向改變
      window.addEventListener('orientationchange', this.handleOrientationChange)
      // 監聽頁面可見性變化（用戶切換標籤頁後返回）
      document.addEventListener('visibilitychange', this.handleVisibilityChange)
    },
    
    // 停止裝置監控
    stopDeviceMonitoring() {
      window.removeEventListener('resize', this.handleResize)
      window.removeEventListener('orientationchange', this.handleOrientationChange)
      document.removeEventListener('visibilitychange', this.handleVisibilityChange)
      
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }
    },
    
    // 處理視窗大小改變
    handleResize() {
      // 防抖處理，避免頻繁檢查
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }
      
      this.resizeTimer = setTimeout(() => {
        this.checkDevice()
      }, 300)
    },
    
    // 處理方向改變
    handleOrientationChange() {
      // 延遲檢查，確保方向改變完成
      setTimeout(() => {
        this.checkDevice()
      }, 500)
    },
    
    // 處理頁面可見性變化
    handleVisibilityChange() {
      if (!document.hidden) {
        // 頁面變為可見時重新檢查
        setTimeout(() => {
          this.checkDevice()
        }, 100)
      }
    },
    
    // 檢查裝置類型
    checkDevice() {
      if (this.isCheckingDevice) return
      
      this.isCheckingDevice = true
      
      try {
        const deviceInfo = getDeviceInfo()
        console.log('Device Info:', deviceInfo)
        
        // 檢查是否為行動裝置
        if (!isMobile()) {
          console.log('非行動裝置，導向 Mobile 頁面')
          
          // 只有在不是 Mobile 頁面時才跳轉，避免無限循環
          if (this.$route.path !== '/mobile') {
            this.$router.push('/mobile')
          }
        } else {
          console.log('偵測到行動裝置')
          
          // 如果在 Mobile 頁面但已經是行動裝置，導回首頁
          if (this.$route.path === '/mobile') {
            this.$router.push('/')
          }
        }
      } catch (error) {
        console.error('裝置偵測錯誤:', error)
      } finally {
        this.isCheckingDevice = false
      }
    }
  },
  created() {
    // 初始檢查是否為行動裝置
    this.checkDevice()
  },
  
  // 監聽路由變化，確保每個頁面都進行裝置檢查
  watch: {
    '$route'() {
      // 路由變化時重新檢查裝置
      this.$nextTick(() => {
        this.checkDevice()
      })
    }
  }
}
</script>
